<div class="cmnitem no-boder">
    <div class="cmnitem__left">
        <caremoni-treenode-item *ngIf="isEditTtlSetting"
            [isTreeNode]="true" 
            [searchParams]="paramsForTreeNode" 
            (eventUpdateData)="onUpdateDataCondition($event)" 
            [notValidIds]="notValidIds"
            [placeHolderFilter]="placeholder">
        </caremoni-treenode-item>
        <caremoni-textbox *ngIf="!isEditTtlSetting"
            [inputParams]="inputParams"
            [inputValue]="paramsForTreeNode.objectData.selectedNode.itemname">
        </caremoni-textbox>
    </div>
    <div class="cmnitem__center">
        <caremoni-drop-down *ngIf="isEditTtlSetting && isShowKirokuCondition"
            [searchParams]="paramsForComparison" 
            (onFilterData)="onFilterCondition($event)">
        </caremoni-drop-down>
        <caremoni-textbox *ngIf="!isEditTtlSetting && isShowKirokuCondition"
            [inputParams]="inputParams"
            [inputValue]="paramsForComparison.selected"
        >
        </caremoni-textbox>
    </div>
    <div class="cmnitem__right">
        <caremoni-textbox *ngIf="!isEditTtlSetting && isShowKirokuCondition && isShowComplete"
            [inputParams]="inputParams"
            [inputValue]="conditionItem.val"
        ></caremoni-textbox>
        <caremoni-auto-complete-item 
             *ngIf="isEditTtlSetting && isShowKirokuCondition && isShowComplete"
            [_disable] = "!isEditTtlSetting"
            [data]="itemValues"
            [officecd]="officecd"
            [selectedItem]="conditionItem.val" 
            [conditionItem]="conditionItem"
            [keyChangeItem]="keyChangeItem"
            (onChangeItemValue)="onChangeItemValue($event)">
        </caremoni-auto-complete-item>
    </div>
    <div class="cmnitem__removeitem" *ngIf="isEditTtlSetting">
        <i [ngClass] = "{'disabled': !isAllowRemoveCondition}" class="pi pi-times-circle" (click)="onRemove(conditionItem.id)"></i>
    </div>
</div>
